/* eslint-env browser, jquery */
/* global PricingWidget */
import qs from 'qs';
import rg from 'modules/npm-component/require-global';
import loggedin from 'modules/loggedin';
import bus from 'modules/npm-component/bus';

export default function PricingPartial(options) {
  options = options || {};

  this.track = options.track;

  // Expose widgets for AB Testing
  window.pricingWidgets = [];

  this.featuresPartial = options.featuresPartial;

  this.onLoggedinChange = this.onLoggedinChange.bind(this);
}

PricingPartial.prototype.load = function(batch) {
  batch.push(done => {
    rg('//cdn2.auth0.com/pricing-widget/pricing-widget-4.12.0.min.js', 'PricingWidget', done);
  });
};

PricingPartial.prototype.activate = function() {
  this.$plans = $('[data-plan]');

  $('.js-see-all-type-features').click(this.onSeeAllTypeFeatures.bind(this));

  this.$plans.each((index, el) => {
    const $el = $(el);
    $el.on('click', '.js-plan-contact-sales', this.onContactSales.bind(this));
  });

  loggedin.onChange(this.onLoggedinChange);

  bus.on('page:change', this.onDestroy.bind(this));
};

PricingPartial.prototype.onDestroy = function() {
  loggedin.removeChangeListener(this.onLoggedinChange);
};

PricingPartial.prototype.onLoggedinChange = function(loggedin) {
  this.$plans = $('[data-plan]');
  this.$plans.each((index, el) => {
    const $el = $(el);
    if (loggedin) {
      $el.find('.js-start-now').addClass('hide');
      $el.find('.js-buy-now').removeClass('hide');
    } else {
      $el.find('.js-start-now').removeClass('hide');
      $el.find('.js-buy-now').addClass('hide');
    }
  });
};

PricingPartial.prototype.render = function() {
  this.$plans.each((i, planContainer) => {
    const planKey = planContainer.getAttribute('data-plan');
    const widget = new PricingWidget(planContainer);

    window.pricingWidgets.push(widget);

    widget.on(
      widget.events.SUBSCRIPTION_COST_CHANGED,
      this.onSubscriptionCostChange.bind(this, planContainer)
    );

    widget.on(widget.events.SUBSCRIPTION_CHECKOUT, this.onStartNow.bind(this));
  });
};

PricingPartial.prototype.onSubscriptionCostChange = function(
  planContainer,
  cost,
  planType,
  users,
  recurrence,
  appliesForCustomDeal
) {
  const planKey = planContainer.getAttribute('[data-plan]');
  this.disablePlanCheckout(planContainer, planType !== 'free' && !cost);

  this.track(`change:plan-subscription-cost:${planKey}`, {
    plan: planKey,
    type: planType,
    users,
    recurrence,
    appliesForCustomDeal
  });
};

PricingPartial.prototype.disablePlanCheckout = function(planContainer, shouldDisable) {
  $(planContainer)
    .find('[data-plan-checkout]')
    .attr('disabled', shouldDisable);
};

PricingPartial.prototype.onSeeAllFeatures = function(event) {
  const planKey = this._getPlanKey(event);

  event.preventDefault();

  this.featuresPartial.setPlanHighlighting(planKey);

  this.track(`click:plan-see-all-features:${planKey}`, { plan: planKey });
};

PricingPartial.prototype.onSeeAllTypeFeatures = function(event) {
  const planType = $(event.target).data('planType');

  this.featuresPartial.moveTo(planType);

  this.track(`click:plan-see-all-features-type:${planType}`, { planType });
};

PricingPartial.prototype.onStartNow = function(subscription) {
  const qsPayload = qs.stringify({
    type: subscription.plan,
    users: subscription.users,
    recurrence: subscription.recurrence
  });

  window.signup(null, { authParams: { state: qsPayload } });

  this.track(`click:plan-start-now:${subscription.plan}`, { plan: subscription.plan });
};

PricingPartial.prototype.setRecurrence = function(recurrence) {
  window.pricingWidgets.forEach(widget => {
    widget.setRecurrence(recurrence);
  }, this);

  this.track('select:pricing-packages-interval', { value: recurrence });
};

PricingPartial.prototype.onContactSales = function(event) {
  const planKey = this._getPlanKey(event);

  this.track(`click:plan-contact-sales:${planKey}`, { plan: planKey });
};

PricingPartial.prototype._getPlanKey = function(event) {
  return $(event.target)
    .closest('[data-plan]')
    .data('plan');
};



// WEBPACK FOOTER //
// ./src/components/pricingPlans/vendor/partials/pricing-partial.js